import React from "react";

const Group79 = () => {
      return(
            <div className="vector-parent">
                  <img className="group-child" alt="" src="/line-1.svg" />
                  <img className="group-item" alt="" src="/line-1.svg" />
                  <img className="group-inner" alt="" src="/line-1.svg" />
                  <b className="podcast">Podcast</b>
            </div>
      );
};

export default Group79;